import { Box, Divider, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { alertListType } from '../types';
import { deleteAlertById, getAlertByClients } from '../../../features/alerts/requests';
import AlertsTable from './components/AlertsTable';
import AlertConditionsTable from './components/AlertConditionsTable';
import usePaymentModal from '../../../features/predictionMap/hooks/usePaymentModal';
import { authType } from '../../../features/client/types';
import { useLoaderData } from 'react-router-dom';
import useFetchUser from '../../../features/client/hooks/useFetchUser';
import { sendAnalyticsEvent } from '../../../utils/googleAnalytics';

const AlertListPage: React.FC = () => {
  const { t } = useTranslation();

  const [alertListFromApi, setAlertListFromApi] = useState<alertListType>([]);
  const [selectedRow, setSelectedRow] = useState<number | null>(null);
  const authInfo = useLoaderData() as authType;
  const { isPaid, loading } = useFetchUser(authInfo.user.cognito_username);
  const { togglePaymentModal, PaymentModal } = usePaymentModal('alert');

  // FIXME: useLoaderの中に移動する
  useEffect(() => {
    if (!isPaid) {
      togglePaymentModal();
      return;
    }

    if (!loading) {
      const getAlerts = async () => {
        const res = await getAlertByClients();
        return res;
      };
      getAlerts().then(res => {
        setAlertListFromApi(res);
      });
    }
  }, [isPaid, loading]);

  const handleDeleteClick = (id: string) => async () => {
    await deleteAlertById(id);
    // GA4: アラート削除成功を計測
    sendAnalyticsEvent('alert_form', {
      action: 'delete_success',
    });
    await getAlertByClients().then(res => {
      setAlertListFromApi(res);
    });
  };

  return (
    <Box>
      {PaymentModal}
      <Box style={{ padding: '24px 24px 16px 24px' }}>
        <Typography style={{ fontWeight: 'bold', fontSize: '14pt', paddingBottom: '4px' }}>
          {t('common.menu.alertList')}
        </Typography>
        <AlertsTable
          alertList={alertListFromApi}
          setSelectedRow={setSelectedRow}
          selectedRow={selectedRow}
          handleDeleteClick={handleDeleteClick}
        />
      </Box>
      <Divider />
      <Box style={{ padding: '24px 24px 0px 24px' }}>
        <AlertConditionsTable alertList={alertListFromApi} selectedRow={selectedRow} />
      </Box>
    </Box>
  );
};

export default AlertListPage;
